import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form';
import { withContainerCrud } from '../../../../../components/Utils';
import { salvar, listar } from "../../actions";
import OkReportDeveloperPesquisa from '../OkReportDeveloperPesquisa'

import { listar as listarPerfis } from '../../../../admin/ConsultaPerfisAdmin/actions'

const mapStateToProps = ({ OkReportReducer }, props) => {
    let tipoModelo = null;
    if (props.location && props.location.state)
        tipoModelo = props.location.state.tipoModelo;
    let initialValues = {
        code_conteudo: `function relatorio(dados) {
            //console.log("dados", dados)
            let l = dados;
            let conteudo1 = [];
        
            conteudo1.push(painel(      [
                [
                    { style: "cellTitulo", text: "UID" }, 
                    { style: "cellValor", text: l.uid }
                ],                
            ], { widths: [70, '*'] }))
           
            return conteudo1
        
        }`
    }

    if (tipoModelo) {
        initialValues.tipoModelo = tipoModelo
    }

    const pesquisa = <OkReportDeveloperPesquisa />;
    return {
        initialValues,
        permiteNovo: true,
        pesquisa,
        crudControl: OkReportReducer.rCrudSalvar,
        jsonGerar: OkReportReducer.jsonGerar
    };
};

export default compose(
    connect(mapStateToProps, { salvar, listarPerfis }),
    reduxForm({
        form: 'OkReportForm',
    }),
    withContainerCrud({ titulo: "Desenvolvimento de Relatórios" })
);


// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/OkReportDeveloperForm/OkReportDeveloperForm.enhancer.js